module.exports = __webpack_public_path__ + "22c7ee699db36fa10651218bd9cfcf53.svg";